import { createSelector } from 'reselect';

const selectprograms = (state: any) => state.programs;


export const selectprogramsCurrentItem = createSelector([selectprograms], (programs) => programs.current);

export const selectprogramsListItems = createSelector([selectprograms], (programs) => programs.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectprogramsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectprogramsQueryItems = createSelector([selectprograms], (programs) => programs.query);

export const selectprogramsCreatedItem = createSelector([selectprograms], (programs) => programs.create);

export const selectprogramsUpdatedItem = createSelector([selectprograms], (programs) => programs.update);

export const selectprogramsReadItem = createSelector([selectprograms], (programs) => programs.read);

export const selectprogramsDeletedItem = createSelector([selectprograms], (programs) => programs.delete);

export const selectprogramsSearchedItems = createSelector([selectprograms], (programs) => programs.search);

export const selectprogramsItemsCount = createSelector([selectprograms], (programs) => programs.count);

export const selectprogramsItemsFilter = createSelector([selectprograms], (programs) => programs.filter);